<template>
  <i-modal class="fineart-prompt"
           width="595"
           :title="title"
           :value="isShowed"
           @on-visible-change="changeHandler">
    <i-form>
      <i-form-item>
        <i-input
          v-model="value"
          :type="inputType"
          :placeholder="placeHolder"></i-input>
      </i-form-item>
    </i-form>
    <div slot="footer">
      <div class="l-flex-end l-flex-grow-1">
        <i-button type="text" size="large" @click="cancelModel">取消</i-button>
        <i-button type="primary" size="large" @click="handleSubmit">确定</i-button>
      </div>
    </div>
  </i-modal>
</template>

<script>
import { Modal, Input, Form, FormItem } from 'iview'

export default {
  name: 'FineartPrompt',
  data () {
    return {
      value: ''
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    isShowed: {
      type: Boolean,
      default: false
    },
    placeHolder: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      default: 'text'
    },
    defaultValue: {
      type: String,
      default: ''
    }
  },
  computed: {
  },
  model: {
    prop: 'isShowed',
    event: 'change-show'
  },
  created () {
    this.value = this.defaultValue
  },
  methods: {
    cancelModel () {
      this.$emit('change-show', false) // 关闭弹窗
    },
    changeHandler (isShowed) {
      this.$emit('change-show', isShowed)
    },
    handleSubmit () {
      if (!this.value) {
        this.$store.commit('ADD_MESSAGE', {
          type: 'error',
          msg: '请' + this.placeHolder
        })
        return
      }
      this.$emit('confirm', this.value) // 返回保存数据
      this.value = this.defaultValue
    }
  },
  components: {
    'i-modal': Modal,
    'i-form': Form,
    'i-input': Input,
    'i-form-item': FormItem
  }
}
</script>

<style lang="stylus">
.fineart-prompt .ivu-modal-content .ivu-modal-body
  overflow: unset!important
</style>



// WEBPACK FOOTER //
// src/components/FineartPrompt.vue